/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const TRACKER_QUERY_KEYS = {
  all: ['trackers'] as const,
  /** The organization's trackers; a segment no workspace id can collide with. */
  organization: () => [...TRACKER_QUERY_KEYS.all, 'organization'] as const,
  people: (search: string) => [...TRACKER_QUERY_KEYS.all, 'people', search] as const,
  detail: (workspaceId: string, trackerId: string) =>
    [...TRACKER_QUERY_KEYS.all, workspaceId, trackerId] as const,
  items: (workspaceId: string, trackerId: string) =>
    [...TRACKER_QUERY_KEYS.all, workspaceId, trackerId, 'items'] as const,
  members: (workspaceId: string, trackerId: string) =>
    [...TRACKER_QUERY_KEYS.all, workspaceId, trackerId, 'members'] as const,
  scope: (workspaceId: string, trackerId: string) =>
    [...TRACKER_QUERY_KEYS.all, workspaceId, trackerId, 'scope'] as const,
  /** Every rows query for one board, whatever it is filtered or sorted by. */
  allRows: (workspaceId: string, trackerId: string) =>
    [...TRACKER_QUERY_KEYS.all, workspaceId, trackerId, 'rows'] as const,
  rows: (workspaceId: string, trackerId: string, params: unknown) =>
    [...TRACKER_QUERY_KEYS.allRows(workspaceId, trackerId), params] as const,
};
